import Measurer from "../Measurer";
import RFAbstract from "./RFAbstract";

export default class RFFullHeightDragable extends RFAbstract {

    constructor(interactionHandler) {
        super(interactionHandler);
    }

    getRestraints() {

        // die Tür als ganzes nimmt beim Drag/Drop immer den kompletten Platz ein, der
        // nicht von Fronten belegt wird

        const fullHeightVsData = this.dragObject3d.vsData;
        const ranges = [];
        APP.arrangement.iterateElements(element=> {
            if (fullHeightVsData.acceptElement(element)) {
                const fits = new Measurer(Measurer.CENTER).getFullHeightYFits(fullHeightVsData, element);
                const box = element.localToSchrankBox(fullHeightVsData.getElementBox(element));
                fits.forEach(fit=>ranges.push({fit,element,box}));
            }
        });
        let restraints = this._mapFitsToRestraints(ranges,{fitDragIntoBox: true});

        return this._addRoomAndRemoveRestraints(restraints);
    }

}
